<template>
  <a-modal :title="title" :width="width" :visible="visible" :confirmLoading="confirmLoading" @ok="handleOk"
    @cancel="handleCancel" cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="模块编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'couponCode', validatorRules.couponCode]" placeholder="请输入模块编码"></a-input>
        </a-form-item>
        <a-form-item label="主图" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-upload v-decorator="['mainPicAddress', validatorRules.mainPicAddress]" :trigger-change="true"
            :uploadData="uploadData1" :beforeUpload="beforeUpload" :num="1"></j-upload>
        </a-form-item>
        <a-form-item label="详情图" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-upload :multiple="true" v-decorator="['detailPicAddress', validatorRules.detailPicAddress]"
            :uploadData="uploadData2" :beforeUpload="beforeUploadDetail" :trigger-change="true">
          </j-upload>
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea v-decorator="['remarks', validatorRules.remarks]" rows="4" placeholder="请输入备注" />
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import {
    httpAction
  } from '@/api/manage'
  import pick from 'lodash.pick'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import JUpload from '../../components/JUpload.vue'

  export default {
    name: "PaltenCodeModal",
    components: {
      JUpload,
    },
    data() {
      return {
        form: this.$form.createForm(this),
        title: "操作",
        width: 800,
        visible: false,
        model: {},
        labelCol: {
          xs: {
            span: 24
          },
          sm: {
            span: 5
          },
        },
        wrapperCol: {
          xs: {
            span: 24
          },
          sm: {
            span: 16
          },
        },
        confirmLoading: false,
        validatorRules: {
          couponCode: {
            rules: [{
              required: true,
              message: '请填写模块编码！',
              trigger: 'change'
            }]
          },
          mainPicAddress: {
            rules: [{
              required: true,
              message: '请上传主图！',
              trigger: 'change'
            }]
          },
          detailPicAddress: {
            rules: []
          },
          remarks: {
            rules: [{
              required: true,
              message: '请填写备注！',
              trigger: 'change'
            }]
          },
        },
        url: {
          add: "/palten/base/paltenCode/add",
          edit: "/palten/base/paltenCode/edit",
        }
      }
    },
    created() {},
    methods: {
      add() {
        this.edit({});
      },
      edit(record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model, 'couponCode', 'mainPicAddress', 'detailPicAddress', 'remarks'))
        })
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据", formData)
            httpAction(httpurl, formData, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }

        })
      },
      handleCancel() {
        this.close()
      },
      popupCallback(row) {
        this.form.setFieldsValue(pick(row, 'couponCode', 'mainPicAddress', 'detailPicAddress', 'remarks'))
      },


      beforeUpload(file, fileList) {
        console.log('fileList', fileList, fileList.length);
        const couponCode = this.form.getFieldValue('couponCode')
        if (!couponCode) {
          this.$message.warning('请输入模块编码')
          fileList.forEach((item, index, input) => {
            if (item.lastModified == file.lastModified) {
              fileList.splice(index, 1)
            }
          })
          return false
        }
        if (fileList.length == 2) {
          this.$message.warning('最多上传一张主图')
          fileList.forEach((item, index, input) => {
            if (item.lastModified == file.lastModified) {
              fileList.splice(index, 1)
            }
          })
          return false
        }
        var fileType = file.type
        if (fileType === 'image') {
          if (fileType.indexOf('image') < 0) {
            this.$message.warning('请上传图片')
            return false
          }
        } else if (fileType === 'file') {
          if (fileType.indexOf('image') >= 0) {
            this.$message.warning('请上传文件')
            return false
          }
        }
        //TODO 扩展功能验证文件大小
        return true
      },
      beforeUploadDetail(file, fileList) {
        const couponCode = this.form.getFieldValue('couponCode')
        if (!couponCode) {
          this.$message.warning('请输入模块编码')
          fileList.forEach((item, index, input) => {
            if (item.lastModified == file.lastModified) {
              fileList.splice(index, 1)
            }
          })
          return false
        }
        var fileType = file.type
        if (fileType === 'image') {
          if (fileType.indexOf('image') < 0) {
            this.$message.warning('请上传图片')
            return false
          }
        } else if (fileType === 'file') {
          if (fileType.indexOf('image') >= 0) {
            this.$message.warning('请上传文件')
            return false
          }
        }
        //TODO 扩展功能验证文件大小
        return true
      },
      uploadData1() {
        let filepathData = 'paltenCode/' + this.form.getFieldValue('couponCode')
        return {
          filePath: filepathData
        }
      },
      uploadData2() {
        let filepathData = 'paltenCodeDetail/' + this.form.getFieldValue('couponCode')
        return {
          filePath: filepathData
        }
      },

    }
  }
</script>